export const CLOSE_ICON = require(`../../assets/img/icons/close_icon.svg`);
export const GROUP_ICON = require(`../../assets/img/icons/group.png`)


